
    import _Handlebars from 'handlebars/runtime';

    var Handlebars = _Handlebars.default;
    import "@canvas/i18n";
import "@canvas/handlebars-helpers/index.js";

    var template = Handlebars.template, templates = Handlebars.templates = Handlebars.templates || {};
    var name = '/work/generated/ui/shared/assignments/jst/-available-date-description';
    templates[name] = template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var buffer = "", stack1, helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression, self=this;

function program1(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n  <strong class=\"status-description\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("assignments.available_date_description")
  },data:data},helper ? helper.call(depth0, "assignments.available_date_description.not_available_until", "Not available until", options) : helperMissing.call(depth0, "t", "assignments.available_date_description.not_available_until", "Not available until", options)))
    + "</strong>\n  <span "
    + escapeExpression((helper = helpers.contextSensitiveDatetimeTitle || (depth0 && depth0.contextSensitiveDatetimeTitle),options={hash:{},data:data},helper ? helper.call(depth0, (depth0 && depth0.unlockAt), options) : helperMissing.call(depth0, "contextSensitiveDatetimeTitle", (depth0 && depth0.unlockAt), options)))
    + " aria-hidden=\"true\">\n    "
    + escapeExpression((helper = helpers.datetimeFormatted || (depth0 && depth0.datetimeFormatted),options={hash:{},data:data},helper ? helper.call(depth0, (depth0 && depth0.unlockAt), options) : helperMissing.call(depth0, "datetimeFormatted", (depth0 && depth0.unlockAt), options)))
    + "\n  </span>\n  <span class=\"screenreader-only\">"
    + escapeExpression((helper = helpers.contextSensitiveDatetimeTitle || (depth0 && depth0.contextSensitiveDatetimeTitle),options={hash:{
    'justText': (true)
  },data:data},helper ? helper.call(depth0, (depth0 && depth0.unlockAt), options) : helperMissing.call(depth0, "contextSensitiveDatetimeTitle", (depth0 && depth0.unlockAt), options)))
    + "</span>\n";
  return buffer;
  }

function program3(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n  <strong class=\"status-description\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("assignments.available_date_description")
  },data:data},helper ? helper.call(depth0, "assignments.available_date_description.available_until", "Available until", options) : helperMissing.call(depth0, "t", "assignments.available_date_description.available_until", "Available until", options)))
    + "</strong>\n  <span "
    + escapeExpression((helper = helpers.contextSensitiveDatetimeTitle || (depth0 && depth0.contextSensitiveDatetimeTitle),options={hash:{},data:data},helper ? helper.call(depth0, (depth0 && depth0.lockAt), options) : helperMissing.call(depth0, "contextSensitiveDatetimeTitle", (depth0 && depth0.lockAt), options)))
    + " aria-hidden=\"true\">\n    "
    + escapeExpression((helper = helpers.datetimeFormatted || (depth0 && depth0.datetimeFormatted),options={hash:{},data:data},helper ? helper.call(depth0, (depth0 && depth0.lockAt), options) : helperMissing.call(depth0, "datetimeFormatted", (depth0 && depth0.lockAt), options)))
    + "\n  </span>\n  <span class=\"screenreader-only\">"
    + escapeExpression((helper = helpers.contextSensitiveDatetimeTitle || (depth0 && depth0.contextSensitiveDatetimeTitle),options={hash:{
    'justText': (true)
  },data:data},helper ? helper.call(depth0, (depth0 && depth0.lockAt), options) : helperMissing.call(depth0, "contextSensitiveDatetimeTitle", (depth0 && depth0.lockAt), options)))
    + "</span>\n";
  return buffer;
  }

function program5(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n  <span class=\"status-description\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("assignments.available_date_description")
  },data:data},helper ? helper.call(depth0, "assignments.available_date_description.closed", "Closed", options) : helperMissing.call(depth0, "t", "assignments.available_date_description.closed", "Closed", options)))
    + "</span>\n";
  return buffer;
  }

  stack1 = helpers['if'].call(depth0, (depth0 && depth0.pending), {hash:{},inverse:self.noop,fn:self.program(1, program1, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n\n";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.open), {hash:{},inverse:self.noop,fn:self.program(3, program3, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n\n";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.closed), {hash:{},inverse:self.noop,fn:self.program(5, program5, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n";
  return buffer;
  });
    
      Handlebars.registerPartial('ui/shared/assignments/jst/_available_date_description.handlebars', templates['/work/generated/ui/shared/assignments/jst/-available-date-description']);
    ;
    ;
    export default templates[name];
  